import { atomFamily } from "jotai/utils";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

const sessionCounterOfferAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<undefined | number>(`counterOffer-${sessionId}`, undefined)
);

export const counterOfferAtom = createDerivedSessionAtom<undefined | number>(sessionCounterOfferAtom);
